import { Control, Controller, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ReactCreatableSelect from 'react-select/creatable';

import { DropdownIndicator } from 'coreOld/elements';

interface IProps {
  name: string;
  value?: string | number | string[] | number[];
  defaultValue?: string | number | string[] | number[];
  placeholder?: string;
  menuIsOpen?: boolean;
  customStyles?;
  control?: Control<FieldValues, object>;
  isMulti?: boolean;
  mapDataToFilters: (options, onChange) => void;
  showDropdownIcon?: boolean;
  disabled?: boolean;
  editable?: boolean;
  getValue?;
  getLabel?;
  onChange?;
  options?;
  isLoadingOptions?: boolean;
  onKeyDown?;
  isClearable?: boolean;
  onCreateOption?: (inputValue: string) => void;
  formatCreateLabel?: (inputValue: string) => JSX.Element;
}

const CreatableSelectWithControllerView = ({
  name,
  control,
  value,
  defaultValue,
  customStyles,
  options,
  isLoadingOptions = false,
  placeholder,
  menuIsOpen,
  isMulti = false,
  showDropdownIcon = true,
  disabled = false,
  editable = true,
  getLabel,
  getValue,
  mapDataToFilters,
  onKeyDown,
  isClearable = false,
  onCreateOption,
  formatCreateLabel,
}: IProps) => {
  const { t } = useTranslation();

  const dropdownIndicator = showDropdownIcon && !disabled ? DropdownIndicator : null;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => {
        return (
          <ReactCreatableSelect
            {...field}
            onChange={(option) =>
              isMulti ? mapDataToFilters(option, field.onChange) : field.onChange(getValue(option))
            }
            components={{ DropdownIndicator: dropdownIndicator }}
            value={
              value ?? (field.value && options.find((option) => getValue(option) === field.value))
            }
            getOptionValue={getValue}
            getOptionLabel={(option) => (option.__isNew__ ? option.label : getLabel(option))}
            isMulti={isMulti}
            isClearable={isClearable}
            styles={customStyles}
            options={isLoadingOptions ? [] : options}
            placeholder={disabled && !editable ? '-' : placeholder}
            menuIsOpen={menuIsOpen}
            isDisabled={disabled}
            onKeyDown={(event) => onKeyDown && onKeyDown(event)}
            noOptionsMessage={() =>
              isLoadingOptions ? t('messageLoading') : t('messageNoOptionsAvailable')
            }
            onCreateOption={onCreateOption}
            formatCreateLabel={formatCreateLabel}
            createOptionPosition={'first'}
            menuPortalTarget={document.body}
            closeMenuOnSelect
          />
        );
      }}
    />
  );
};

export default CreatableSelectWithControllerView;
